import {UseHistoryType} from '../../ReportsPage';
import Util from '../../../../shared/util/util';
import {getSavedReportURLByReportType} from '../../../../../components/insights/saved_report_util';
import CreateTemporaryReport from '../../../../../mutations/reporting/CreateTemporaryReportMutation';

import {
	getEyeApplied,
	getGroupingOne,
	getPeriodDate,
	getPeriodType,
} from '../../../../../containers/modal/create-new-report/create-new-report-util';
import type {CreateReportModal_viewer} from './__generated__/CreateReportModal_viewer.graphql';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';
import {endOfMonth, format, startOfMonth} from 'date-fns';

type CompanyType = NonNullable<CreateReportModal_viewer['company']>;

const createReportMutation = (type: string, company: CompanyType, history: UseHistoryType, closeModal: () => void): void => {
	const onSuccess = response => {
		const report = response?.createTemporaryReport?.temporaryReport;
		history.push(getSavedReportURLByReportType(report?.type, report?.id));
		closeModal();
	};

	const today = new Date();
	const startDate = format(startOfMonth(today), 'yyyy-MM-dd');
	const endDate = format(endOfMonth(today), 'yyyy-MM-dd');

	Util.CommitMutation(
		CreateTemporaryReport,
		{
			name: type,
			type: type,
			eyeApplied: JSON.stringify(
				getEyeApplied(
					type,
					company.isUsingProjectAllocation,
					company.isUsingSchedulingPlanMode,
					Util.isMixedAllocationModeEnabled(company)
				)
			),
			startDate,
			endDate,
			filterApplied: JSON.stringify(null),
			filters: [],
			groupingOne: getGroupingOne(type),
			periodType: getPeriodType(type),
			periodDate: getPeriodDate(type),
		},
		onSuccess
	);
};

export const createReport = (): void => {
	showModal({
		type: MODAL_TYPE.CREATE_REPORT_MODAL,
		createReport: (type: string, company: CompanyType, history: UseHistoryType, closeModal: () => void) =>
			createReportMutation(type, company, history, closeModal),
	});
};
